export default __webpack_public_path__ + "static/media/happy-emoji.11365d21.svg";